import { useQuery } from '@tanstack/react-query'
import { fetchDashboardActivity } from '../api/overview'
import type { DashboardActivityItem } from '../types'

export function useDashboardActivity(limit = 8) {
  return useQuery<DashboardActivityItem[]>({
    queryKey: ['dashboard-activity', limit],
    queryFn: () => fetchDashboardActivity(limit),
    staleTime: 30 * 1000,
    refetchInterval: 2 * 60 * 1000,
  })
}
